export const LOAD_DATA = 'loadData';
export const LOAD_LOCATIONSPOSITIONS = 'loadLocationsPositions';
export const LOAD_EMPLOYMENTS = 'loadEmployments';
export const LOAD_SHIFTS = 'loadShifts';
export const LOAD_EVENTS = 'loadEvents';
export const LOAD_ABSENCES = 'loadAbsences';
